import { Model } from '@vuex-orm/core'

export default class Activity extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'activities'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      type: this.attr(null),
      email: this.attr(null),
      move: this.attr(null),
      qualification: this.attr(null),
      meetinsight: this.attr(null),
      note: this.attr(null),
      questionnaire: this.attr(null),
      intervideo: this.attr(null),
      intervoice: this.attr(null),
      event: this.attr(null),
      evaluation: this.attr(null),
      task: this.attr(null),
      placement: this.attr(null),
      candidate: this.attr(null),
      job: this.attr(null),
      author_user: this.attr(null),
      account_id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Activity.js